// Parent-facing reading-journey stage names (HOP-28 decision: keep the
// design handoff's names). They map 1:1 onto the internal six stages
// (stageDefinitions.ts: pre-reader → fluent); internal naming stays.

import type { Learner } from '@/types'

export const HS_STAGE_NAMES = [
  'Sound Explorer',   // 0 · pre-reader
  'Code Cracker',     // 1 · early-beginner
  'Word Builder',     // 2 · late-beginner
  'Pattern Spotter',  // 3 · early-transitional
  'Story Reader',     // 4 · late-transitional
  'Book Adventurer',  // 5 · fluent
] as const

export function hsStageName(learner: Pick<Learner, 'readingStage'> | null | undefined): string {
  if (learner?.readingStage == null) return 'New reader'
  return HS_STAGE_NAMES[learner.readingStage] ?? 'New reader'
}
